const bn = {
    "gui.menuBar.file": "ফাইল",
    "gui.menuBar.edit": "সম্পাদনা",
    "gui.menuBar.new": "নতুন",
    "gui.menuBar.saveNow": "এখনই সংরক্ষণ করো",
    "gui.menuBar.saveAsCopy": "কপি হিসেবে সংরক্ষণ করো",
    "gui.menuBar.remix": "রিমিক্স",
    "gui.menuBar.languageSelector": "ভাষা নির্বাচক",
    "gui.menuBar.tutorialsLibrary": "টিউটোরিয়াল",
    "gui.menuBar.community": "সম্প্রদায়",
    "gui.menuBar.wiki": "এজেন্ট ডাউনলোড করুন",
    "gui.menuBar.restoreSprite": "স্প্রাইট পুনরুদ্ধার করো",
    "gui.menuBar.restoreSound": "শব্দ পুনরুদ্ধার করো",
    "gui.menuBar.restoreCostume": "পোশাক পুনরুদ্ধার করো",
    "gui.menuBar.restore": "পুনরুদ্ধার করো",
    "gui.menuBar.turboModeOff": "টার্বো মোড বন্ধ করো",
    "gui.menuBar.turboModeOn": "টার্বো মোড চালু করো",
    "gui.menuBar.noDeviceSelected": "কোনো ডিভাইস নির্বাচিত নেই",
    "gui.menuBar.noConnection": "সংযোগ নেই",
    "gui.menuBar.downloadToComputer": "কম্পিউটারে ডাউনলোড করো",
    "gui.menuBar.checkUpdate": "আপডেট চেক করো",
    "gui.menuBar.installDriver": "ড্রাইভার ইনস্টল করো",
    "gui.menuBar.clearCacheAndRestart": "ক্যাশ পরিষ্কার করে আবার চালু করো",
    "gui.adblockModal.title": "বিজ্ঞাপন ব্লকার শনাক্ত হয়েছে",
    "gui.adblockModal.body":
        "TIFStudio কে বিজ্ঞাপন ব্লকার বন্ধ করছে। দয়া করে TIFStudio-এর জন্য বিজ্ঞাপন ব্লকার বন্ধ করুন।",
    "gui.adblockModal.reload": "পুনরায় লোড করো",
    "gui.alerts.createsuccess": "নতুন প্রজেক্ট তৈরি হয়েছে।",
    "gui.alerts.createcopysuccess": "প্রজেক্ট কপি হিসেবে সংরক্ষিত হয়েছে।",
    "gui.alerts.createremixsuccess": "প্রজেক্ট রিমিক্স হিসেবে সংরক্ষিত হয়েছে।",
    "gui.alerts.creating": "নতুন তৈরি করা হচ্ছে...",
    "gui.alerts.creatingCopy": "প্রজেক্টের কপি তৈরি করা হচ্ছে...",
    "gui.alerts.creatingRemix": "প্রজেক্টের রিমিক্স তৈরি করা হচ্ছে...",
    "gui.alerts.downloading": "ডাউনলোড হচ্ছে...",
    "gui.alerts.loading": "লোড হচ্ছে...",
    "gui.alerts.saving": "সংরক্ষণ করা হচ্ছে...",
    "gui.alerts.savesuccess": "প্রজেক্ট সংরক্ষিত হয়েছে।",
    "gui.alerts.savingError": "প্রজেক্ট সংরক্ষণ করা যায়নি।",
    "gui.alerts.cloudInfo":
        "দয়া করে মনে রাখবেন, ক্লাউড ভেরিয়েবল শুধুমাত্র সংখ্যা সমর্থন করে, অক্ষর বা চিহ্ন নয়।",
    "gui.alerts.cloudVariableFull": "ক্লাউড ভেরিয়েবলের সীমা পূর্ণ হয়েছে।",
    "gui.alerts.importedSvgTitle": "আপলোড করা SVG ফাইলে সমস্যা",
    "gui.alerts.importedSvgMessage":
        "SVG ফাইল লোড করা যায়নি। এটা কি সঠিক SVG ফাইল?",
    "gui.alerts.importedSvgReset": "আবার চেষ্টা করো",
    "gui.alerts.importedSvgCancel": "বাতিল করো",
    "gui.alerts.uploadError": "আপলোডে ত্রুটি",
    "gui.alerts.uploadSuccess": "আপলোড সফল",
    "gui.gui.addExtension": "এক্সটেনশন যোগ করো",
    "gui.gui.code": "কোড",
    "gui.gui.backdrops": "পটভূমি",
    "gui.gui.costumes": "পোশাক",
    "gui.gui.sounds": "শব্দ",
    "gui.gui.codeTab": "কোড",
    "gui.gui.costumesTab": "পোশাক",
    "gui.gui.backdropsTab": "পটভূমি",
    "gui.gui.soundsTab": "শব্দ",
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.menuBar.turnOffCamera": "ক্যামেরা বন্ধ করুন",
    "gui.menu-bar.realtimeMode": "স্ক্র্যাচ",
    "gui.menu-bar.programMode": "প্ৰোগ্ৰাম",
    "gui.hardwareConsole.send": "পাঠাও",
    "gui.hardwareConsole.buadrate": "বড রেট",
    "gui.hardwareConsole.endOfLine": "লাইনের শেষ",
    "gui.hardwareConsole.hexform": "হেক্স ফর্ম",
    "gui.hardwareConsole.autoScroll": "স্বয়ংক্রিয় স্ক্রল",
    "gui.hardwareHeader.upload": "আপলোড",
    "gui.stageHeader.codeStageSizeLarge": "বড় স্টেজ",
    "gui.stageHeader.codeStageSizeSmall": "ছোট স্টেজ",
    "gui.stageHeader.hideStage": "স্টেজ লুকাও",
    "gui.stageHeader.fullscreenControl": "পূর্ণ পর্দা নিয়ন্ত্রণ",
    "gui.extensionLibrary.comingSoon": "শিগগিরই আসছে",
    "gui.extensionLibrary.requires": "প্রয়োজন",
    "gui.extensionLibrary.collaboration": "এর সহযোগিতায়",
    // Extension Library Metadata
    "gui.extensionLibrary.manufactor": "প্রস্তুতকারক",
    "gui.extensionLibrary.version": "সংস্করণ",
    "gui.extensionLibrary.author": "লেখক",
    "gui.extensionLibrary.programMode": "প্রোগ্রাম মোড",
    "gui.extensionLibrary.programLanguage": "প্রোগ্রাম ভাষা",
    "gui.extensionLibrary.deviceLearnMore": "আরও জানুন",
    "gui.extensionLibrary.extensionHelp": "সাহায্য",
    "gui.extensionLibrary.Processing": "প্রক্রিয়াকরণ হচ্ছে...",
    "gui.extensionLibrary.loaded": "লোড হয়েছে",
    "gui.extensionLibrary.notLoaded": "লোড হয়নি",
    "gui.extensionLibrary.chooseAnExtension": "একটি এক্সটেনশন বেছে নাও",
    "gui.library.filterPlaceholder": "খুঁজুন",
    "gui.library.allTag": "সব",
    "gui.loader.message1": "স্প্রাইট তৈরি করা হচ্ছে...",
    "gui.loader.message2": "শব্দ লোড করা হচ্ছে...",
    "gui.loader.message3": "পোশাক লোড করা হচ্ছে...",
    "gui.loader.message4": "এক্সটেনশন লোড করা হচ্ছে...",
    "gui.loader.message5": "ব্লক তৈরি করা হচ্ছে...",
    "gui.loader.message6": "গণনা করা হচ্ছে...",
    "gui.loader.message7": "লোড হচ্ছে...",
    "gui.loader.message8": "প্রস্তুত করা হচ্ছে...",
    "gui.loader.headline": "প্রজেক্ট লোড হচ্ছে",
    "gui.loader.creating": "প্রজেক্ট তৈরি করা হচ্ছে",
    "gui.spriteLibrary.chooseASprite": "একটি স্প্রাইট বেছে নাও",
    "gui.spriteLibrary.paintASprite": "আঁকো",
    "gui.spriteLibrary.uploadASprite": "স্প্রাইট আপলোড করো",
    "gui.spriteLibrary.surprise": "চমক",
    "gui.soundLibrary.chooseASound": "একটি শব্দ বেছে নাও",
    "gui.soundLibrary.record": "রেকর্ড করো",
    "gui.soundLibrary.uploadASound": "শব্দ আপলোড করো",
    "gui.costumeLibrary.chooseACostume": "একটি পোশাক বেছে নাও",
    "gui.costumeLibrary.paintACostume": "আঁকো",
    "gui.costumeLibrary.uploadACostume": "পোশাক আপলোড করো",
    "gui.backdropLibrary.chooseABackdrop": "একটি পটভূমি বেছে নাও",
    "gui.backdropLibrary.paintABackdrop": "আঁকো",
    "gui.backdropLibrary.uploadABackdrop": "পটভূমি আপলোড করো",
    "gui.spriteSelector.addSpriteFromLibrary": "একটি স্প্রাইট বেছে নাও",
    "gui.spriteSelector.addSpriteFromPaint": "আঁকো",
    "gui.spriteSelector.addSpriteFromSurprise": "চমক",
    "gui.spriteSelector.addSpriteFromFileUpload": "স্প্রাইট আপলোড করো",
    "gui.stageSelector.addBackdropFromLibrary": "একটি পটভূমি বেছে নাও",
    "gui.stageSelector.addBackdropFromPaint": "আঁকো",
    "gui.stageSelector.addBackdropFromSurprise": "চমক",
    "gui.stageSelector.addBackdropFromFileUpload": "পটভূমি আপলোড করো",
    "gui.stageSelector.stage": "স্টেজ",
    "gui.stageSelector.backdrops": "পটভূমি",
    "gui.spriteSelectorItem.contextMenuDuplicate": "কপি করো",
    "gui.spriteSelectorItem.contextMenuExport": "এক্সপোর্ট করো",
    "gui.spriteSelectorItem.contextMenuDelete": "মুছে ফেলো",
    "gui.spriteInfo.sprite": "স্প্রাইট",
    "gui.spriteInfo.size": "আকার",
    "gui.spriteInfo.show": "দেখাও",
    "gui.spriteInfo.changeSize": "আকার বদলাও",
    "gui.spriteInfo.changeX": "X বদলাও",
    "gui.spriteInfo.changeY": "Y বদলাও",
    "gui.spriteInfo.direction": "দিক",
    "gui.spriteInfo.changeDirection": "দিক বদলাও",
    "gui.spriteInfo.isVisible": "দেখা যাচ্ছে",
    "gui.deviceLibrary.chooseADevice": "একটি ডিভাইস বেছে নাও",
    "gui.deviceLibrary.deviceUrl": "ডিভাইসের URL দিন",
    "gui.deviceLibrary.arduinoTag": "Arduino",
    "gui.deviceLibrary.microbitTag": "Micro:bit",
    "gui.deviceLibrary.esp32Tag": "ESP32",
    "gui.deviceLibrary.kitTag": "কিট",
    "gui.deviceLibrary.shieldTag": "শিল্ড",
    "gui.playButton.play": "চালাও",
    "gui.playButton.stop": "থামাও",
    "gui.gui.variableScopeOptionAllSprites": "সব স্প্রাইটের জন্য",
    "gui.gui.variableScopeOptionSpriteOnly": "শুধু এই স্প্রাইটের জন্য",
    "gui.gui.cloudVariableOption": "ক্লাউড ভেরিয়েবল (সার্ভারে সংরক্ষিত)",
    "gui.gui.variablePromptDefaultValue": "আমার ভেরিয়েবল",
    "gui.gui.listVariable": "একটি লিস্ট তৈরি করো",
    "gui.gui.makeAVariable": "একটি ভেরিয়েবল তৈরি করো",
    "gui.gui.newVariable": "নতুন ভেরিয়েবল",
    "gui.soundEditor.sound": "শব্দ",
    "gui.soundEditor.play": "চালাও",
    "gui.soundEditor.stop": "থামাও",
    "gui.soundEditor.copy": "কপি",
    "gui.soundEditor.paste": "পেস্ট",
    "gui.soundEditor.copyToNew": "নতুনতে কপি করো",
    "gui.soundEditor.delete": "মুছে ফেলো",
    "gui.soundEditor.save": "সংরক্ষণ করো",
    "gui.soundEditor.undo": "পূর্বাবস্থায় ফেরত",
    "gui.soundEditor.redo": "আবার করো",
    "gui.soundEditor.faster": "দ্রুত",
    "gui.soundEditor.slower": "ধীর",
    "gui.soundEditor.echo": "প্রতিধ্বনি",
    "gui.soundEditor.robot": "রোবট",
    "gui.soundEditor.louder": "জোরে",
    "gui.soundEditor.softer": "আস্তে",
    "gui.soundEditor.reverse": "উল্টো",
    "gui.soundEditor.fadeOut": "ফেইড আউট",
    "gui.soundEditor.fadeIn": "ফেইড ইন",
    "gui.soundEditor.mute": "নিঃশব্দ",
    "paint.paintEditor.hue": "রং",
    "paint.paintEditor.saturation": "সম্পৃক্তি",
    "paint.paintEditor.brightness": "উজ্জ্বলতা",
    "paint.paintEditor.fill": "ভরাট",
    "paint.paintEditor.costume": "পোশাক",
    "paint.paintEditor.group": "গ্রুপ",
    "paint.paintEditor.ungroup": "গ্রুপ ভাঙো",
    "paint.paintEditor.undo": "পূর্বাবস্থায় ফেরত",
    "paint.paintEditor.redo": "আবার করো",
    "paint.paintEditor.forward": "সামনে আনো",
    "paint.paintEditor.backward": "পিছনে পাঠাও",
    "paint.paintEditor.front": "সবার সামনে",
    "paint.paintEditor.back": "সবার পিছনে",
    "paint.paintEditor.more": "আরও",
    "paint.modeTools.brushSize": "ব্রাশের আকার",
    "paint.modeTools.eraserSize": "ইরেজারের আকার",
    "paint.modeTools.copy": "কপি",
    "paint.modeTools.paste": "পেস্ট",
    "paint.modeTools.delete": "মুছে ফেলো",
    "paint.modeTools.curved": "বাঁকা",
    "paint.modeTools.pointed": "নোড়া",
    "paint.modeTools.thickness": "মোটা",
    "paint.modeTools.flipHorizontal": "আনুভূমিকভাবে উল্টাও",
    "paint.modeTools.flipVertical": "উল্লম্বভাবে উল্টাও",
    "paint.modeTools.filled": "ভরা",
    "paint.modeTools.outlined": "রেখাঙ্কিত",
    "paint.paintEditor.bitmap": "বিটম্যাপে রূপান্তর",
    "paint.paintEditor.vector": "ভেক্টরে রূপান্তর",
    "paint.paintEditor.stroke": "রেখা",
    "paint.brushMode.brush": "ব্রাশ",
    "paint.eraserMode.eraser": "ইরেজার",
    "paint.fillMode.fill": "ভরাট",
    "paint.lineMode.line": "রেখা",
    "paint.ovalMode.oval": "উপবৃত্ত",
    "paint.rectMode.rect": "আয়তক্ষেত্র",
    "paint.reshapeMode.reshape": "আকার বদলাও",
    "paint.roundedRectMode.roundedRect": "গোলাকার আয়তক্ষেত্র",
    "paint.selectMode.select": "নির্বাচন",
    "paint.textMode.text": "টেক্সট",
    "paint.colorPicker.swap": "অদলবদল",
    "gui.uploadProgress.uploading": "আপলোড হচ্ছে",
    "gui.uploadProgress.uploadSuccess": "আপলোড সফল",
    "gui.uploadProgress.uploadError": "আপলোডে ত্রুটি",
    "gui.uploadProgress.close": "বন্ধ করো",
    "gui.uploadProgress.abort": "বাতিল করো",
    "gui.connection.connect": "সংযোগ করো",
    "gui.connection.disconnect": "সংযোগ বিচ্ছিন্ন করো",
    "gui.connection.connected": "সংযুক্ত",
    "gui.connection.connecting": "সংযোগ করা হচ্ছে...",
    "gui.connection.error": "ত্রুটি",
    "gui.connection.unavailable": "অনুপলব্ধ",
    "gui.connection.noDevicesFound": "কোনো ডিভাইস পাওয়া যায়নি",
    "gui.connection.scanning": "স্ক্যান করা হচ্ছে...",
    "gui.connection.help": "সাহায্য",
    "gui.connection.refresh": "রিফ্রেশ",
    "blockly.deleteBlock": "ব্লক মুছে ফেলো",
    "blockly.duplicateBlock": "কপি করো",
    "blockly.addComment": "মন্তব্য যোগ করো",
    "blockly.removeComment": "মন্তব্য সরাও",
    "blockly.externalInput": "বাহ্যিক ইনপুট",
    "blockly.inlineInput": "ইনলাইন ইনপুট",
    "blockly.disableBlock": "ব্লক নিষ্ক্রিয় করো",
    "blockly.enableBlock": "ব্লক সক্রিয় করো",
    "blockly.expandBlock": "ব্লক প্রসারিত করো",
    "blockly.collapseBlock": "ব্লক সংকুচিত করো",
    "blockly.help": "সাহায্য",
    "blockly.undo": "পূর্বাবস্থায় ফেরত",
    "blockly.redo": "আবার করো",
    "blockly.cleanUp": "ব্লকগুলো গুছিয়ে রাখো",
    "blockly.sortByCategory": "বিভাগ অনুযায়ী সাজাও",
    "blockly.workspaceComment": "ওয়ার্কস্পেস মন্তব্য",
    "blockly.exportToHtml": "HTML হিসেবে এক্সপোর্ট করো",
    "blockly.snapToGrid": "গ্রিডে আটকে দাও",
    "blockly.cannotDeleteVariable": "এই ভেরিয়েবল মুছতে পারবে না",
    "blockly.renameVariable": "ভেরিয়েবলের নাম বদলাও",
    "blockly.newVariable": "নতুন ভেরিয়েবল",
    "blockly.renameVariableTitle": 'সব "%1" ভেরিয়েবলের নাম বদলাও:',
    "blockly.variableAlreadyExists": '"%1" নামের ভেরিয়েবল ইতিমধ্যে আছে',

    // Device translations
    "gui.device.unselectDevice.name": "ডিভাইস নির্বাচন বাতিল করো",
    "gui.device.unselectDevice.description":
        "ডিভাইস নির্বাচন বাতিল করো, বিশুদ্ধ রিয়েলটাইম প্রোগ্রামিং মোডে ফিরে যাও।",
    "gui.device.connectingMessage": "সংযোগ করা হচ্ছে",
    "gui.device.arduinoUno.description":
        "ইলেকট্রনিক্স এবং কোডিং শুরু করার জন্য একটি দুর্দান্ত বোর্ড।",
    "gui.device.arduinoNano.description":
        "Arduino Nano তোমার প্রজেক্ট তৈরি করার জন্য একটি ক্লাসিক ছোট বোর্ড।",
    "gui.device.arduinoLeonardo.description":
        "ক্লাসিক Arduino বোর্ড যা মাউস বা কীবোর্ড হিসেবে কাজ করতে পারে।",
    "gui.device.arduinoMega2560.description":
        "54টি ডিজিটাল পিন, 16টি অ্যানালগ ইনপুট এবং 4টি সিরিয়াল পোর্ট সহ 8-বিট বোর্ড।",
    "gui.device.arduinoUnoR4Minima.description":
        "উন্নত পারফরম্যান্স এবং সম্প্রসারিত মেমরি প্রদান করে, বিদ্যমান শিল্ড এবং আনুষাঙ্গিকগুলির সাথে সামঞ্জস্যতা বজায় রাখে।",
    "gui.device.arduinoUnoR4Wifi.description":
        "Wi-Fi এবং Bluetooth সংযোগ প্রদান করে, সাথে ভিজুয়ালাইজেশনের জন্য অন-বোর্ড 12x8 LED ম্যাট্রিক্স।",
    "gui.device.esp32.description":
        "সমৃদ্ধ কার্যকারিতা সহ Wi-Fi এবং Bluetooth নিয়ন্ত্রণ বোর্ড।",
    "gui.device.esp32S3.description":
        "দক্ষ, কম-শক্তি IoT এজ এবং AI ওয়ার্কলোডের জন্য ডেডিকেটেড AI অ্যাক্সিলারেটর এবং সমৃদ্ধ পেরিফেরাল সেট একত্রিত করে।",
    "gui.device.esp8266NodeMCU.description":
        "কম খরচের Wi-Fi SOC নিয়ন্ত্রণ বোর্ড।",
    "gui.device.k210MaixDock.description":
        "K210 RISC-V চিপ ভিত্তিক একটি নিয়ন্ত্রণ বোর্ড যার শুধুমাত্র মৌলিক কার্যকারিতা আছে এবং সমস্ত IO পিন বের করা হয়েছে।",
    "gui.device.k210Maixduino.description": "ESP32 সহ K210 RISC-V বোর্ড।",
    "gui.device.raspberryPiPicoIconURL.description":
        "তোমার ইলেকট্রনিক্স ধারণাগুলিকে জীবন্ত করে তোলা একটি বন্ধুত্বপূর্ণ, ব্যবহার করা সহজ মাইক্রোকন্ট্রোলার বোর্ড।",
    "gui.device.raspberryPiPicoWIconURL.description":
        "ওয়্যারলেস এবং IoT প্রজেক্টের জন্য নিখুঁত বিল্ট-ইন 2.4 GHz Wi-Fi এবং Bluetooth 5.2 সহ Pico।",
    "gui.device.raspberryPiPico2IconURL.description":
        "জটিল অ্যাপ্লিকেশনের জন্য পর্যাপ্ত RAM এবং ফ্ল্যাশ সহ উচ্চ-পারফরম্যান্স ডুয়াল-কোর MCU।",
    "gui.device.raspberryPiPico2WIconURL.description":
        "নির্বিঘ্ন ওয়্যারলেস IoT এবং স্মার্ট-হোম ইন্টিগ্রেশনের জন্য বিল্ট-ইন 2.4 GHz Wi-Fi এবং Bluetooth।",
    "gui.device.microbit.description":
        "ডিজিটাল দক্ষতা শেখা রূপান্তরিত করা পকেট-আকারের কম্পিউটার।",
    "gui.device.microbitV2.description":
        "আপগ্রেড করা প্রসেসর, বিল্ট-ইন স্পিকার এবং মাইক্রোফোন, স্পর্শ সংবেদনশীল লোগো।",
    "gui.device.makeymakey.description": "যেকোনো কিছুকে একটি কী-তে পরিণত করো।",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.device.tifBot.description":
        "TIF-BOT হলো একটি ESP32-S3 ভিত্তিক বোর্ড যাতে Wi-Fi, Bluetooth এবং রোবোটিক্স ও IoT প্রকল্পের জন্য সমৃদ্ধ peripherals রয়েছে।",
    "gui.device.lightWingDrone.description":
        "লাইট উইং ড্রোন হলো একটি উচ্চ-কর্মক্ষমতাসম্পন্ন ESP32-S3 ভিত্তিক ফ্লাইট কন্ট্রোলার যাতে উন্নত স্থিতিশীলতা এবং Wi-Fi নিয়ন্ত্রণ রয়েছে।",
    "gui.device.roboticDog.description":
        "Robotic Dog হলো Arduino Nano দ্বারা চালিত একটি স্মার্ট চতুষ্পদ রোবট, যা জীবন্তসদৃশ চলাচল এবং বাধা এড়ানোর ক্ষমতা রাখে।",
    "gui.device.roboticArm.description":
        "Robotic Arm হলো Arduino Nano দ্বারা চালিত একটি মাল্টি-অক্ষ ম্যানিপুলেটর, যা নির্ভুল কাজ এবং অটোমেশন শেখার জন্য ডিজাইন করা হয়েছে।",
    // Extension Library Names and Descriptions
    "gui.extension.music.name": "সঙ্গীত",
    "gui.extension.music.description": "বাদ্যযন্ত্র এবং ড্রাম বাজান।",
    "gui.extension.pen.name": "পেন",
    "gui.extension.pen.description": "আপনার স্প্রাইট দিয়ে ছবি আঁকুন।",
    "gui.extension.videosensing.name": "ভিডিও সেন্সিং",
    "gui.extension.videosensing.description":
        "ক্যামেরার সাহায্যে গতি শনাক্ত করুন।",
    "gui.extension.poseface.name": "ফেস সেন্সিং",
    "gui.extension.poseface.description":
        "ক্যামেরার সাহায্যে মুখের নড়াচড়া শনাক্ত করুন।",
    "gui.extension.posehand.name": "হ্যান্ড সেন্সিং",
    "gui.extension.posehand.description":
        "ক্যামেরার সাহায্যে হাতের নড়াচড়া শনাক্ত করুন।",
    "gui.extension.posebody.name": "বডি পোজ সেন্সিং",
    "gui.extension.posebody.description":
        "ক্যামেরার সাহায্যে শরীরের নড়াচড়া শনাক্ত করুন।",
    "gui.extension.teachablemachine.name": "টিচেবল মেশিন",
    "gui.extension.teachablemachine.description":
        "আপনার ক্যামেরার সাথে কাস্টম মেশিন লার্নিং মডেল ব্যবহার করুন।",
    "gui.extension.text2speech.name": "টেক্সট টু স্পিচ",
    "gui.extension.text2speech.description": "আপনার প্রজেক্টকে কথা বলান।",
    "gui.extension.translate.name": "অনুবাদ",
    "gui.extension.translate.description": "টেক্সট বিভিন্ন ভাষায় অনুবাদ করুন।",
    "gui.extension.makeymakey.name": "মেকি মেকি",
    "gui.extension.makeymakey.description":
        "যেকোনো কিছুকে একটি কীতে (Key) পরিণত করুন।",

    // Arduino Translations
    "arduinoUno.category.pins": "পিন",
    "arduinoUno.category.serial": "সিরিয়াল",
    "arduinoUno.category.data": "ডেটা",

    "arduinoNano.category.pins": "পিন",
    "arduinoNano.category.serial": "সিরিয়াল",
    "arduinoNano.category.data": "ডেটা",

    "arduinoLeonardo.category.pins": "পিন",
    "arduinoLeonardo.category.serial": "সিরিয়াল",
    "arduinoLeonardo.category.data": "ডেটা",

    "arduinoMega2560.category.pins": "পিন",
    "arduinoMega2560.category.serial": "সিরিয়াল",
    "arduinoMega2560.category.data": "ডেটা",

    "arduinoEsp32.category.pins": "পিন",
    "arduinoEsp32.category.serial": "সিরিয়াল",
    "arduinoEsp32.category.data": "ডেটা",

    "arduinoEsp8266.category.pins": "পিন",
    "arduinoEsp8266.category.serial": "সিরিয়াল",
    "arduinoEsp8266.category.data": "ডেটা",

    "arduinoK210.category.pins": "পিন",
    "arduinoK210.category.serial": "সিরিয়াল",
    "arduinoK210.category.data": "ডেটা",

    "arduinoRaspberryPiPico.category.pins": "পিন",
    "arduinoRaspberryPiPico.category.serial": "সিরিয়াল",
    "arduinoRaspberryPiPico.category.data": "ডেটা",

    // Arduino Uno Blocks
    "arduinoUno.modeMenu.input": "ইনপুট",
    "arduinoUno.modeMenu.output": "আউটপুট",
    "arduinoUno.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoUno.levelMenu.high": "হাই (High)",
    "arduinoUno.levelMenu.low": "লো (Low)",
    "arduinoUno.pins.setPinMode": "পিন [PIN] মোড [MODE] সেট করুন",
    "arduinoUno.pins.setDigitalOutput":
        "ডিজিটাল পিন [PIN] আউট [LEVEL] সেট করুন",
    "arduinoUno.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoUno.pins.readDigitalPin": "ডিজিটাল পিন [PIN] পড়ুন",
    "arduinoUno.pins.readAnalogPin": "এনালগ পিন [PIN] পড়ুন",
    "arduinoUno.pins.setServoOutput": "সার্ভো পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoUno.pins.attachInterrupt":
        "ইন্টারাপ্ট পিন [PIN] মোড [MODE] যুক্ত করুন",
    "arduinoUno.pins.detachInterrupt": "ইন্টারাপ্ট পিন [PIN] বিচ্ছিন্ন করুন",
    "arduinoUno.serial.serialBegin": "সিরিয়াল শুরু বাউডরেট [VALUE]",
    "arduinoUno.serial.serialPrint": "সিরিয়াল প্রিন্ট [VALUE] [EOL]",
    "arduinoUno.serial.serialAvailable": "সিরিয়াল উপলব্ধ ডেটা দৈর্ঘ্য",
    "arduinoUno.serial.serialReadAByte": "সিরিয়াল একটি বাইট পড়ুন",
    "arduinoUno.data.dataMap":
        "[DATA] কে ([ARG0], [ARG1]) থেকে ([ARG2], [ARG3]) তে ম্যাপ করুন",

    // Arduino Nano Blocks
    "arduinoNano.modeMenu.input": "ইনপুট",
    "arduinoNano.modeMenu.output": "আউটপুট",
    "arduinoNano.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoNano.levelMenu.high": "হাই (High)",
    "arduinoNano.levelMenu.low": "লো (Low)",
    "arduinoNano.pins.setPinMode": "পিন [PIN] মোড [MODE] সেট করুন",
    "arduinoNano.pins.setDigitalOutput":
        "ডিজিটাল পিন [PIN] আউট [LEVEL] সেট করুন",
    "arduinoNano.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoNano.pins.readDigitalPin": "ডিজিটাল পিন [PIN] পড়ুন",
    "arduinoNano.pins.readAnalogPin": "এনালগ পিন [PIN] পড়ুন",
    "arduinoNano.pins.setServoOutput": "সার্ভো পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoNano.pins.attachInterrupt":
        "ইন্টারাপ্ট পিন [PIN] মোড [MODE] যুক্ত করুন",
    "arduinoNano.pins.detachInterrupt": "ইন্টারাপ্ট পিন [PIN] বিচ্ছিন্ন করুন",
    "arduinoNano.serial.serialBegin": "সিরিয়াল শুরু বাউডরেট [VALUE]",
    "arduinoNano.serial.serialPrint": "সিরিয়াল প্রিন্ট [VALUE] [EOL]",
    "arduinoNano.serial.serialAvailable": "সিরিয়াল উপলব্ধ ডেটা দৈর্ঘ্য",
    "arduinoNano.serial.serialReadAByte": "সিরিয়াল একটি বাইট পড়ুন",
    "arduinoNano.data.dataMap":
        "[DATA] কে ([ARG0], [ARG1]) থেকে ([ARG2], [ARG3]) তে ম্যাপ করুন",

    // Arduino Leonardo Blocks
    "arduinoLeonardo.modeMenu.input": "ইনপুট",
    "arduinoLeonardo.modeMenu.output": "আউটপুট",
    "arduinoLeonardo.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoLeonardo.levelMenu.high": "হাই (High)",
    "arduinoLeonardo.levelMenu.low": "লো (Low)",
    "arduinoLeonardo.pins.setPinMode": "পিন [PIN] মোড [MODE] সেট করুন",
    "arduinoLeonardo.pins.setDigitalOutput":
        "ডিজিটাল পিন [PIN] আউট [LEVEL] সেট করুন",
    "arduinoLeonardo.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoLeonardo.pins.readDigitalPin": "ডিজিটাল পিন [PIN] পড়ুন",
    "arduinoLeonardo.pins.readAnalogPin": "এনালগ পিন [PIN] পড়ুন",
    "arduinoLeonardo.pins.setServoOutput":
        "সার্ভো পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoLeonardo.pins.attachInterrupt":
        "ইন্টারাপ্ট পিন [PIN] মোড [MODE] যুক্ত করুন",
    "arduinoLeonardo.pins.detachInterrupt":
        "ইন্টারাপ্ট পিন [PIN] বিচ্ছিন্ন করুন",
    "arduinoLeonardo.serial.serialBegin": "সিরিয়াল শুরু বাউডরেট [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "সিরিয়াল প্রিন্ট [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialAvailable": "সিরিয়াল উপলব্ধ ডেটা দৈর্ঘ্য",
    "arduinoLeonardo.serial.serialReadAByte": "সিরিয়াল একটি বাইট পড়ুন",
    "arduinoLeonardo.data.dataMap":
        "[DATA] কে ([ARG0], [ARG1]) থেকে ([ARG2], [ARG3]) তে ম্যাপ করুন",

    // Arduino Mega2560 Blocks
    "arduinoMega2560.modeMenu.input": "ইনপুট",
    "arduinoMega2560.modeMenu.output": "আউটপুট",
    "arduinoMega2560.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoMega2560.levelMenu.high": "হাই (High)",
    "arduinoMega2560.levelMenu.low": "লো (Low)",
    "arduinoMega2560.pins.setPinMode": "পিন [PIN] মোড [MODE] সেট করুন",
    "arduinoMega2560.pins.setDigitalOutput":
        "ডিজিটাল পিন [PIN] আউট [LEVEL] সেট করুন",
    "arduinoMega2560.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoMega2560.pins.readDigitalPin": "ডিজিটাল পিন [PIN] পড়ুন",
    "arduinoMega2560.pins.readAnalogPin": "এনালগ পিন [PIN] পড়ুন",
    "arduinoMega2560.pins.setServoOutput":
        "সার্ভো পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoMega2560.pins.attachInterrupt":
        "ইন্টারাপ্ট পিন [PIN] মোড [MODE] যুক্ত করুন",
    "arduinoMega2560.pins.detachInterrupt":
        "ইন্টারাপ্ট পিন [PIN] বিচ্ছিন্ন করুন",
    "arduinoMega2560.serial.serialBegin": "সিরিয়াল শুরু বাউডরেট [VALUE]",
    "arduinoMega2560.serial.serialPrint": "সিরিয়াল প্রিন্ট [VALUE] [EOL]",
    "arduinoMega2560.serial.serialAvailable": "সিরিয়াল উপলব্ধ ডেটা দৈর্ঘ্য",
    "arduinoMega2560.serial.serialReadAByte": "সিরিয়াল একটি বাইট পড়ুন",
    "arduinoMega2560.data.dataMap":
        "[DATA] কে ([ARG0], [ARG1]) থেকে ([ARG2], [ARG3]) তে ম্যাপ করুন",

    // Arduino ESP32 Blocks
    "arduinoEsp32.modeMenu.input": "ইনপুট",
    "arduinoEsp32.modeMenu.output": "আউটপুট",
    "arduinoEsp32.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoEsp32.levelMenu.high": "হাই (High)",
    "arduinoEsp32.levelMenu.low": "লো (Low)",
    "arduinoEsp32.pins.setPinMode": "পিন [PIN] মোড [MODE] সেট করুন",
    "arduinoEsp32.pins.setDigitalOutput":
        "ডিজিটাল পিন [PIN] আউট [LEVEL] সেট করুন",
    "arduinoEsp32.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoEsp32.pins.readDigitalPin": "ডিজিটাল পিন [PIN] পড়ুন",
    "arduinoEsp32.pins.readAnalogPin": "এনালগ পিন [PIN] পড়ুন",
    "arduinoEsp32.pins.setServoOutput": "সার্ভো পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoEsp32.pins.attachInterrupt":
        "ইন্টারাপ্ট পিন [PIN] মোড [MODE] যুক্ত করুন",
    "arduinoEsp32.pins.detachInterrupt": "ইন্টারাপ্ট পিন [PIN] বিচ্ছিন্ন করুন",
    "arduinoEsp32.serial.serialBegin": "সিরিয়াল শুরু বাউডরেট [VALUE]",
    "arduinoEsp32.serial.serialPrint": "সিরিয়াল প্রিন্ট [VALUE] [EOL]",
    "arduinoEsp32.serial.serialAvailable": "সিরিয়াল উপলব্ধ ডেটা দৈর্ঘ্য",
    "arduinoEsp32.serial.serialReadAByte": "সিরিয়াল একটি বাইট পড়ুন",
    "arduinoEsp32.data.dataMap":
        "[DATA] কে ([ARG0], [ARG1]) से ([ARG2], [ARG3]) তে ম্যাপ করুন",

    // Arduino ESP8266 Blocks
    "arduinoEsp8266.modeMenu.input": "ইনপুট",
    "arduinoEsp8266.modeMenu.output": "আউটপুট",
    "arduinoEsp8266.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoEsp8266.levelMenu.high": "হাই (High)",
    "arduinoEsp8266.levelMenu.low": "লো (Low)",
    "arduinoEsp8266.pins.setPinMode": "পিন [PIN] মোড [MODE] সেট করুন",
    "arduinoEsp8266.pins.setDigitalOutput":
        "ডিজিটাল পিন [PIN] আউট [LEVEL] সেট করুন",
    "arduinoEsp8266.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoEsp8266.pins.readDigitalPin": "ডিজিটাল পিন [PIN] পড়ুন",
    "arduinoEsp8266.pins.readAnalogPin": "এনালগ পিন [PIN] পড়ুন",
    "arduinoEsp8266.pins.setServoOutput": "সার্ভো পিন [PIN] আউট [OUT] সেট করুন",
    "arduinoEsp8266.pins.attachInterrupt":
        "ইন্টারাপ্ট পিন [PIN] মোড [MODE] যুক্ত করুন",
    "arduinoEsp8266.pins.detachInterrupt":
        "ইন্টারাপ্ট পিন [PIN] বিচ্ছিন্ন করুন",
    "arduinoEsp8266.serial.serialBegin": "সিরিয়াল শুরু বাউডরেট [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "সিরিয়াল প্রিন্ট [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialAvailable": "সিরিয়াল উপলব্ধ ডেটা দৈর্ঘ্য",
    "arduinoEsp8266.serial.serialReadAByte": "সিরিয়াল একটি বাইট পড়ুন",
    "arduinoEsp8266.data.dataMap":
        "[DATA] কে ([ARG0], [ARG1]) থেকে ([ARG2], [ARG3]) তে ম্যাপ করুন",
    // Additional Data Blocks
    "arduinoUno.data.dataConstrain":
        "[DATA] কে ([ARG0], [ARG1]) এর মধ্যে সীমাবদ্ধ করুন",
    "arduinoUno.data.dataConvert": "[DATA] কে [TYPE] এ রূপান্তর করুন",
    "arduinoUno.data.dataConvertASCIICharacter":
        "[DATA] কে ASCII অক্ষরে রূপান্তর করুন",
    "arduinoUno.data.dataConvertASCIINumber":
        "[DATA] কে ASCII নম্বরে রূপান্তর করুন",
    "arduinoUno.dataTypeMenu.integer": "পূর্ণসংখ্যা",
    "arduinoUno.dataTypeMenu.decimal": "দশমিক",
    "arduinoUno.dataTypeMenu.string": "স্ট্রিং",

    "arduinoNano.data.dataConstrain":
        "[DATA] কে ([ARG0], [ARG1]) এর মধ্যে সীমাবদ্ধ করুন",
    "arduinoNano.data.dataConvert": "[DATA] কে [TYPE] এ রূপান্তর করুন",
    "arduinoNano.data.dataConvertASCIICharacter":
        "[DATA] কে ASCII অক্ষরে রূপান্তর করুন",
    "arduinoNano.data.dataConvertASCIINumber":
        "[DATA] কে ASCII নম্বরে রূপান্তর করুন",
    "arduinoNano.dataTypeMenu.integer": "পূর্ণসংখ্যা",
    "arduinoNano.dataTypeMenu.decimal": "দশমিক",
    "arduinoNano.dataTypeMenu.string": "স্ট্রিং",

    "arduinoLeonardo.data.dataConstrain":
        "[DATA] কে ([ARG0], [ARG1]) এর মধ্যে সীমাবদ্ধ করুন",
    "arduinoLeonardo.data.dataConvert": "[DATA] কে [TYPE] এ রূপান্তর করুন",
    "arduinoLeonardo.data.dataConvertASCIICharacter":
        "[DATA] কে ASCII অক্ষরে রূপান্তর করুন",
    "arduinoLeonardo.data.dataConvertASCIINumber":
        "[DATA] কে ASCII নম্বরে রূপান্তর করুন",
    "arduinoLeonardo.dataTypeMenu.integer": "পূর্ণসংখ্যা",
    "arduinoLeonardo.dataTypeMenu.decimal": "দশমিক",
    "arduinoLeonardo.dataTypeMenu.string": "স্ট্রিং",

    "arduinoMega2560.data.dataConstrain":
        "[DATA] কে ([ARG0], [ARG1]) এর মধ্যে সীমাবদ্ধ করুন",
    "arduinoMega2560.data.dataConvert": "[DATA] কে [TYPE] এ রূপান্তর করুন",
    "arduinoMega2560.data.dataConvertASCIICharacter":
        "[DATA] কে ASCII অক্ষরে রূপান্তর করুন",
    "arduinoMega2560.data.dataConvertASCIINumber":
        "[DATA] কে ASCII নম্বরে রূপান্তর করুন",
    "arduinoMega2560.dataTypeMenu.integer": "পূর্ণসংখ্যা",
    "arduinoMega2560.dataTypeMenu.decimal": "দশমিক",
    "arduinoMega2560.dataTypeMenu.string": "স্ট্রিং",

    "arduinoEsp32.data.dataConstrain":
        "[DATA] কে ([ARG0], [ARG1]) এর মধ্যে সীমাবদ্ধ করুন",
    "arduinoEsp32.data.dataConvert": "[DATA] কে [TYPE] এ রূপান্তর করুন",
    "arduinoEsp32.data.dataConvertASCIICharacter":
        "[DATA] কে ASCII অক্ষরে রূপান্তর করুন",
    "arduinoEsp32.data.dataConvertASCIINumber":
        "[DATA] কে ASCII নম্বরে রূপান্তর করুন",
    "arduinoEsp32.dataTypeMenu.integer": "পূর্ণসংখ্যা",
    "arduinoEsp32.dataTypeMenu.decimal": "দশমিক",
    "arduinoEsp32.dataTypeMenu.string": "স্ট্রিং",

    "arduinoEsp8266.data.dataConstrain":
        "[DATA] কে ([ARG0], [ARG1]) এর মধ্যে সীমাবদ্ধ করুন",
    "arduinoEsp8266.data.dataConvert": "[DATA] কে [TYPE] এ রূপান্তর করুন",
    "arduinoEsp8266.data.dataConvertASCIICharacter":
        "[DATA] কে ASCII অক্ষরে রূপান্তর করুন",
    "arduinoEsp8266.data.dataConvertASCIINumber":
        "[DATA] কে ASCII নম্বরে রূপান্তর করুন",
    "arduinoEsp8266.dataTypeMenu.integer": "পূর্ণসংখ্যা",
    "arduinoEsp8266.dataTypeMenu.decimal": "দশমিক",
    "arduinoEsp8266.dataTypeMenu.string": "স্ট্রিং",
    // Library manager & Board manager
    "gui.librariesBoardsTab": "লাইব্রেরিসমূহ",
    "gui.boardManagerTab": "বোর্ড ম্যানেজার",

    "gui.boardManager.title": "বোর্ড ম্যানেজার",
    "gui.boardManager.description":
        "অফিসিয়াল Arduino বোর্ড খুঁজুন এবং ইনস্টল করুন।",
    "gui.boardManager.searchPlaceholder":
        "Arduino বোর্ড খুঁজুন (উদাহরণ: esp32)",
    "gui.boardManager.search": "খুঁজুন",
    "gui.boardManager.searching": "খুঁজছে...",
    "gui.boardManager.advancedOptionsShow": "▶ উন্নত অপশন (কাস্টম ইনস্টল পাথ)",
    "gui.boardManager.advancedOptionsHide": "▼ উন্নত অপশন লুকান",
    "gui.boardManager.recommended": "প্রস্তাবিত",
    "gui.boardManager.installed": "ইনস্টল করা ({count})",
    "gui.boardManager.searchResults": "অনুসন্ধান ফলাফল {count}",
    "gui.boardManager.refresh": "↻ রিফ্রেশ",
    "gui.boardManager.refreshing": "↻ রিফ্রেশ হচ্ছে...",

    "gui.libraryManager.title": "লাইব্রেরি ম্যানেজার",
    "gui.libraryManager.description":
        "অফিসিয়াল Arduino লাইব্রেরি খুঁজুন এবং ইনস্টল করুন।",
    "gui.libraryManager.searchPlaceholder":
        "Arduino লাইব্রেরি খুঁজুন (উদাহরণ: Servo)",
    "gui.libraryManager.search": "খুঁজুন",
    "gui.libraryManager.searching": "খুঁজছে...",
    "gui.libraryManager.advancedOptionsShow":
        "▶ উন্নত অপশন (কাস্টম ইনস্টল পাথ)",
    "gui.libraryManager.advancedOptionsHide": "▼ উন্নত অপশন লুকান",
    "gui.libraryManager.recommended": "প্রস্তাবিত",
    "gui.libraryManager.installed": "ইনস্টল করা ({count})",
    "gui.libraryManager.searchResults": "অনুসন্ধান ফলাফল {count}",
    "gui.libraryManager.refresh": "↻ রিফ্রেশ",
    "gui.libraryManager.refreshing": "↻ রিফ্রেশ হচ্ছে...",
    "gui.gui.librariesBoardsTab": "লাইব্রেরি",
    "gui.gui.boardsManagerTab": "বোর্ড ম্যানেজার",
};

export default bn;
